import { render, staticRenderFns } from "./CreateMilestoneInfo.vue?vue&type=template&id=8433d81c&scoped=true"
import script from "./CreateMilestoneInfo.vue?vue&type=script&lang=js"
export * from "./CreateMilestoneInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateMilestoneInfo.vue?vue&type=style&index=0&id=8433d81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8433d81c",
  null
  
)

export default component.exports